import { z } from 'zod'
import { getProfileByUserNameQueryDocument } from './(gql)/get-profile-by-username'
import { Client } from 'urql'

export function createUserNameSchema(client: Client, profileId: number): z.ZodEffects<z.ZodString, string, string> {
  return z
    .string()
    .min(3, 'Username must be at least 3 characters')
    .max(24, 'Username must be less than 24 characters')
    .regex(/^[a-z0-9]+([._-][a-z0-9]+)*$/, 'Can only use lowercase letters, numbers, and single . _ - as separators.')
    .refine(async (value) => {
      const result = await client.query(getProfileByUserNameQueryDocument, { username: value }).toPromise()
      return (result.data?.user_profiles.filter((profile) => profile.id !== profileId).length ?? 0) === 0
    }, 'Username is already taken, please try another.')
}
